<template>
	<div class="m-banner" :style="{'height': `${height}px`}">
		<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == 0}" :style="{'height': `${height}px`}">
			<a>
				<sub-image class="image" :src="item.img_url" mode="aspectFill" :style="{'width': `${width}px`, 'height': `${height}px`, 'margin': `0 ${unitData.margin == 1 ? 10 : 0}px`}"></sub-image>
			</a>
		</div>
		
		<div class="nav">
			<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == 0}"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		computed: {
			width() {
				return this.unitData.margin == 1 ? 355 : 375;
			},
			
			height() {
				if (this.unitData.list && this.unitData.list[0]) {
					return this.unitData.list[0].img_height / 2 * this.width / 375;
				}
				
				return this.width;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-banner {
		position: relative;
		overflow: hidden;
		
		> .item {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			text-align: center;
			opacity: 0;
			transition: opacity .3s ease;
			
			&.z-crt {
				z-index: 1;
				opacity: 1;
			}
		}
		
		.nav {
			z-index: 1;
			position: absolute;
			right: 14px
			bottom: 40px;
			font-size: 0;
			
			.item {
				display: inline-block;
				width: 5px;
				height: 5px;
				border-radius: 2.5px;
				margin-left: 3px;
				background: rgba(255,255,255,.8);
				
				&.z-crt {
					width: 20px;
				}
			}
		}
	}
</style>
